import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

import { BaseChartDirective } from 'ng2-charts';
import { Ticket, TicketAggregate } from 'src/app/models/ticket/ticket.model';

@Component({
  selector: 'app-ticket-top',
  templateUrl: 'ticket-top.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TicketTopComponent {
  @Output() timeRangeChanged = new EventEmitter();

  @Input() tickets: Ticket[];

  @Input() isLoading: boolean = false;

  @Input() aggregate: TicketAggregate | null = null;

  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  public iconDetail = 'assignment';

  onTimeRangeChanged(timeRange: string): void {
    this.timeRangeChanged.emit(timeRange);
  }
}
